import React, {useEffect, useReducer, useRef, useState} from "react";
import {classNames, getProp} from "../../../../common/util/util-helpers";
import {Field, FieldsManager} from "../../../../data/services/fields";
import {checkPerm, formatMoney, getUser} from "../../../../util/util";
import Resources from "../../../../data/services/resources";
import {getResource, resetResource, updateResource} from "../../../../data/actions/resource";
import {useSelector} from "react-redux";
import {genericMoneyFormatter} from "../../../../common/util/util-vanilla";
import LocalStorage from "../../../../util/localStorage";
import {numberWithCommasToBack} from "../../../../util/util-formaters";
import WorkOrdersLaborPartsPrices from "./work-orders-labor-parts-prices";
import {fieldsToHtml, fillFieldsFromData} from "../../../../common/util/util-fields";
import Card from "../../../../common/components/card";
import ModalConfirm from "../../../../common/components/modal/modal-confirm";
import ResourceTable from "../../../../common/components/resource-table";
import NoRecords from "../../../../common/components/no-records-found/no-records";
import {
    CheckCircleIcon,
    DocumentIcon,
    InformationCircleIcon,
    PencilIcon,
    PlusIcon,
    TrashIcon,
    XCircleIcon
} from "@heroicons/react/24/outline";
import Buttons from "../../../../common/components/buttons";
import PageTabWithFooter from "../../../../common/components/layout/layout-components/page/page-tab-with-footer";
import ModalSaveResource from "../../../../common/components/modal/modal-save-resource";
import Button from "../../../../common/components/button";
import InfoParagraph from "../../../../common/components/info-paragraph";
import ModalDefault from "../../../../common/components/modal/modal-default";
import Env from "../../../../util/env";
import {getJWT} from "../../../../common/util/util-auth";
import {
    DEFAULT_METADATA_SELECT_SEARCH_QUERY,
    OCR_DOCUMENT_ACCEPTABLE_EXTENSIONS,
    READ_PERM
} from "../../../../common/util/util-consts";
import axios from "axios";
import WorkOrdersLaborPartsAiModal from "./work-orders-labor-parts-ai-modal";
import Bot from "../../../../assets/images/bot.png";
import ErrorCodeHelpAiModal from "./error-code-help-ai-modal";
import Tippy from "@tippyjs/react";
import {XMarkIcon} from "@heroicons/react/20/solid";
import EmailEstimate from "./email-estimate";
import CellButton from "../../../../common/components/resource-table/table-components/cell-button";
import FieldOptions from "../../../../common/components/fields/field-options";
import InfoBar from "../../../../common/components/info-paragraph/info-bar";
import {getSecondResource} from "../../../../data/actions/secondResource";
import InventoryReportDialog from "../../../../common/components/modal/inventory-report-dialog";
import {processResponse} from "../../../../data/services/api-util";
import ResourceTableDialog from "../../../../common/components/modal/resource-table-dialog";
import {DEFAULT_QUERY} from "../../../../util/util-constants";
import WoLaborPartsOcr from "./wo-labor-parts-ocr";
import DropZoneAlt from "../../../../common/components/dropzone/drop-zone-alt";
import FieldsForm from "../../../../common/components/fields/fields-form";
import {LoaderSmall} from "../../../../common/components/loader";

const selects = {
    CustomCodeID: {
        api: 'api/' + Resources.WorkOrdersCustomCodes,
        query: {},
        searchMap: (it) => ({
            label: it.CustomCode,
            value: it.CustomCodeID,
        })
    },
    ServiceBayID: {
        api: 'api/' + Resources.ServiceBaysQuick,
        query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
        searchMap: (item) => ({
            value: item.ServiceBayID,
            label: item.BayNumber,
            metadata: item
        })
    },
    AssignedContactID: {
        api: 'api/' + Resources.Contacts,
        query: {
            limit: 20,
            offset: 0,
            IsTechnician: 1
        },
        searchMap: (it) => ({
            label: `${it.FirstName} ${it.LastName}`,
            value: it.ContactID,
        })
    },
    ActionItemStatusID: {
        1: "Open",
        2: "Rejected",
        3: "In progress",
        4: "Completed"
    },
    ChargeToContactID: {
        api: 'api/' + Resources.ContactsQuick,
        query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
        searchMap: (item) => ({
            value: item.ContactID,
            label: item.FirstName + ' ' + item.LastName,
            Contact: item
        })
    }
}

export default function WorkOrdersLaborPartsTab({dispatch, ID, translate, WorkOrder, isInvoiced, WoRepairShopON, isStateDirty, setIsStateDirty}) {
    const dropZoneRef = useRef();
    const popoverButtonRef = useRef();
    /** Constants
     ================================================================= */
    const resource = useSelector((state) => state.resource);
    const isLoading = getProp(resource, "isLoading", true);
    const thirdResource = useSelector(state => state.thirdResource);
    const dialogResource = useSelector(state => state.dialogResource);
    const secondResource = useSelector(state => state.secondResource);
    const isLoadingSecond = getProp(secondResource, "isLoading", true);
    const dataSettings = getProp(resource, "data.Settings", [])


    const dataUnit = getProp(resource, "data.Unit", {
        Type: "Truck",
        Year: "Unspecified",
        Manufacturer: "Unspecified",
        Model: "Unspecified",
    })

    const [data, setData] = useState({});
    const items = data?.Items ?? [];
    const miscItems = data?.Misc ?? [];

    const [errors,setErrors] = useState([]);

    const calcPartTotal = (part) =>
        numberWithCommasToBack(part.PartPrice) * (Number(part.PartQty) || 0) * (Number(part.TaxAmount ? part.TaxAmount : 1));

    const calcLaborTotal = (labor) =>
        numberWithCommasToBack(labor.LaborPrice) * (Number(labor.LaborHours) || 0) * (Number(labor.TaxAmount ? labor.TaxAmount : 1));

    const calcMiscTotal = (item) =>
        numberWithCommasToBack(item.MiscPrice) * (Number(item.MiscQty ?? 0)) * (Number(item.TaxAmount ? item.TaxAmount : 1));

    const totalPriceParts = items.reduce((memo, item) => {
        return memo + item['Parts'].reduce((partMemo, part) => {
            return partMemo + calcPartTotal(part);
        }, 0);
    }, 0);

    const totalPriceLabor = items.reduce((memo, item) => {
        return memo + item['Labor'].reduce((laborMemo, labor) => {
            return laborMemo + calcLaborTotal(labor);
        }, 0);
    }, 0);

    const dataMiscTotal = miscItems.reduce((memo, item) => {
        return memo + calcMiscTotal(item);
    }, 0)

    const dataMiscQtyTotal = miscItems.reduce((memo, item) => memo + (Number(item.MiscQty) || 0), 0);
    const dataMiscPriceTotal = miscItems.reduce((memo, item) => memo + (numberWithCommasToBack(item.MiscPrice) || 0), 0);

    const defaultLaborItem = {LaborHours: "1", LaborPrice: formatMoney(dataSettings?.DefaultLaborPrice) ?? ""}

    /** State
     ================================================================= */
    const [fieldsAction, setFieldsAction] = useState({});
    const [initialComplaintFields, setInitialComplaintFields] = useState(getInitialComplaintFields(data, isInvoiced));
    const [postRepairFields, setPostRepairFields] = useState(getPostRepairFields(data, isInvoiced));

    const [isPartsFormDialogOpen, setIsPartsFormDialogOpen] = useState(false);
    const [isLaborFormDialogOpen, setIsLaborFormDialogOpen] = useState(false);
    const [isMiscFormDialogOpen, setIsMiscFormDialogOpen] = useState(false);
    const [aiData, setAiData] = useState(undefined);
    const [aiDialog, setAiDialog] = useState(false);
    const [aiDialogSingle, setAiDialogSingle] = useState(false);
    const [aiSingleIndex, setAiSingleIndex] = useState(null);
    const [aiLoading, setAILoading] = useState(false);
    const [aiItemLoading, setAIItemLoading] = useState([]);
    const [selectedItem, setSelectedItem] = useState(undefined);
    const [selectedReportItem, setSelectedReportItem] = useState(undefined);
    const [confirmDialogData, setConfirmDialogData] = useState({});
    const [partCreateIndex, setPartCreateIndex] = useState(null);
    const [laborCreateIndex, setLaborCreateIndex] = useState(null);
    const [isAppend, setIsAppend] = useState(false);
    const [additionalAiInfo, setAdditionalAiInfo] = useState("");
    const [itemsChecked, setItemsChecked] = useState([]);
    const [isErrorCodeHelpModalOpen, setIsErrorCodeHelpModalOpen] = useState(false);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [selectedInvoiceExpenseItem, setSelectedInvoiceExpenseItem] = useState({});
    const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
    const [isInvoiceExpenseDialogOpen, setIsInvoiceExpenseDialogOpen] = useState(false);
    const [isTemplateImportOpen, setIsTemplateImportOpen] = useState(false);
    const [importMetadata, setImportMetadata] = useState(null)
    const [selectPartDialogOpen, setSelectPartDialogOpen] = useState(false)
    const [partFields, setPartsFields] = useState(getPartsFields(selectedItem, handleViewReportClick, data, toggleSelectPartDialog))
    const [canSubmitPart, setCanSubmitPart] = useState(false)
    const [isDropZoneActive, setIsDropZoneActive] = useState(false);
    const [isOcrModalOpen, setIsOcrModalOpen] = useState(false);
    const [ocrFile, setOcrFile] = useState(null);


    const handleInputChange = (name, value, index, fields) => {
        if (name === "ServiceBayID") {
            if (value.metadata.PrimaryTechnicianID) {
                fields.AssignedContactID.value = {
                    label: value.metadata.PrimaryTechnician,
                    value: value.metadata.PrimaryTechnicianID
                }
            } else fields.AssignedContactID.value = null
        }

        setFieldsAction(prevState => ({
            ...prevState,
            [index]: FieldsManager.updateField(fields, name, value)
        }))
        setIsStateDirty(true);
    }
    /** Data Events
     ================================================================= */
    const fetchData = () => {
        dispatch(getResource({
            user: getUser(),
            resource: Resources.WorkOrderParts,
            query: {WorkOrderID: ID}
        }))
    }

    const handleConfirmDeletePartClick = (item, index) => {
        let itemsUpdate = [...items];
        itemsUpdate[index]['Parts'].splice(item.dataIndex, 1);

        if (item.ChildPartID !== null && item.ChildPartID !== undefined) {
            itemsUpdate[index]['Parts'] = itemsUpdate[index]['Parts'].filter((it) => it.ParentPartID !== item.ChildPartID);
        }

        closeConfirmDialog();
        setData(prevData => {
            const dataUpdate = Object.assign({}, prevData);
            dataUpdate.Items = itemsUpdate;
            return dataUpdate;
        });
        setIsStateDirty(true);
    }

    const handleConfirmDeleteLaborClick = (item, index) => {
        let itemsUpdate = [...items];
        itemsUpdate[index]['Labor'].splice(item.dataIndex, 1);

        closeConfirmDialog();
        setData(prevData => {
            const dataUpdate = Object.assign({}, prevData);
            dataUpdate.Items = itemsUpdate;
            return dataUpdate;
        });
        setIsStateDirty(true);
    }

    const handleConfirmDeleteMiscClick = (item) => {
        let itemsUpdate = [...miscItems];
        itemsUpdate.splice(item.dataIndex, 1);

        closeConfirmDialog();
        setData(prevData => {
            const dataUpdate = Object.assign({}, prevData);
            dataUpdate.Misc = itemsUpdate;
            return dataUpdate;
        });
        setIsStateDirty(true);
    }

    const handleCancelClick = () => {
        setConfirmDialogData({
            isOpen: true,
            onClick: () => handleConfirmCancelClick(),
            type: "danger",
            content:
                `Are you sure you want to discard all changes?`
            ,
            title: translate("Delete unsaved changes"),
            buttonLabel: translate("btn.delete")
        })
    }
    const handleConfirmCancelClick = () => {

        fetchData();
        isInitialFieldsSet.current = false;
        closeConfirmDialog();

        setIsStateDirty(false);
    }
    /** UI Events
     ================================================================= */
    const handleAddNewItemClick = () => {
        const newIndex = data?.Items?.length ?? 0;

        setData(prevData => {
            const dataUpdate = Object.assign({}, prevData);
            dataUpdate.Items = [...(dataUpdate.Items || []), {
                "Parts": [],
                "Labor": []
            }];

            return dataUpdate
        });

        setFieldsAction(prevData => {
            return {
                ...prevData,
                [newIndex]: getFieldsAction(null, isInvoiced, dataSettings)
            };
        });
    }
    const handleAddLaborClick = (index) => {
        setIsLaborFormDialogOpen(true);
        defaultLaborItem.ind = index;
        defaultLaborItem.dataIndex = items[index]['Labor'].length;
        setSelectedItem(defaultLaborItem);
        setLaborCreateIndex(index)
    }

    const handleAddPartClick = (index) => {
        setIsPartsFormDialogOpen(true);
        setSelectedItem(undefined);
        setPartCreateIndex(index);
        setPartsFields(getPartsFields({}, handleViewReportClick, data, toggleSelectPartDialog))
    }

    const handleEditPartClick = (item, index) => {
        setIsPartsFormDialogOpen(true);
        setPartCreateIndex(index);
        setSelectedItem(item);

    }

    const handleEditLaborClick = (item, index) => {
        setIsLaborFormDialogOpen(true);
        setSelectedItem(item);
        setLaborCreateIndex(index)
    }

    const handleCreateMiscClick = () => {
        setIsMiscFormDialogOpen(true);
        setSelectedItem(undefined);
    }

    const handleEditMiscClick = (item) => {
        setIsMiscFormDialogOpen(true);
        setSelectedItem(item);
    }

    const handleInitialComplaintInputChange = (name, value) => {
        const newFields = FieldsManager.updateField(initialComplaintFields, name, value)
        setInitialComplaintFields(newFields)
        setIsStateDirty(true)
    }

    const handlePostRepairNotesInputChange = (name, value) => {
        const newFields = FieldsManager.updateField(postRepairFields, name, value)
        setPostRepairFields(newFields)
        setIsStateDirty(true)
    }

    const handleLaborInputChange = (fields, name, value) => {
        fields = FieldsManager.updateField(fields, name, value);

        if (name === "TaxID") {
            if (value) {
                fields.Tax.value = value.label
            } else {
                fields.TaxAmount.value = 1
                fields.Tax.value = null
            }
        }

        fields.TaxAmount.value = fields.TaxID?.value?.amount ?? fields.TaxAmount.value

        fields.TotalAmount.value = formatMoney((numberWithCommasToBack(fields.LaborPrice.value) * (Number(fields.LaborHours.value) || 0)) * (Number(fields.TaxAmount.value) || 1));

        return fields;
    }

    const handleMiscInputChange = (fields, name, value) => {
        fields = FieldsManager.updateField(fields, name, value);

        if (name === "ChargeToContactID") {
            if (value) {
                fields.ChargeToContact.value = value.label
            } else {
                fields.ChargeToContact.value = null
            }
        }

        if (name === "TaxID") {
            if (value) {
                fields.Tax.value = value.label
            } else {
                fields.TaxAmount.value = 1
                fields.Tax.value = null
            }
        }

        fields.TaxAmount.value = fields.TaxID?.value?.amount ?? fields.TaxAmount.value

        fields.TotalAmount.value = formatMoney((numberWithCommasToBack(fields.MiscPrice.value) * (Number(fields.MiscQty.value) || 0)) * (Number(fields.TaxAmount.value) || 1));

        return fields;
    }

    const handlePartsInputChange = (fields, name, value) => {
        fields = FieldsManager.updateField(fields, name, value);

        if (name === "TaxID") {
            if (value) {
                fields.Tax.value = value.label
            } else {
                fields.TaxAmount.value = 1
                fields.Tax.value = null
            }
        }

        fields.TaxAmount.value = fields.TaxID?.value?.amount ?? fields.TaxAmount.value

        fields.TotalAmount.value = formatMoney((numberWithCommasToBack(fields.PartPrice.value) * (Number(fields.PartQty.value) || 0)) * (Number(fields.TaxAmount.value) || 1));

        if (name === "PartName" && value) {
            fields.ProductServiceID.value = value.value

            fields.PartNameLabel.value = value.label

            if (value.DirtyProductServiceID) {
                fields.DirtyProductServiceID.value = value.DirtyProductServiceID
                fields.DirtyProductPrice.value = value.DirtyProductPrice
            }

            if (value.InherentProductServiceID) {
                fields.InherentProductServiceID.value = value.InherentProductServiceID
                fields.InherentProductPrice.value = value.InherentProductPrice
            }

            if (value.DirtyProductService) {
                fields.DirtyProductService.value = value.DirtyProductService
            }

            if (value.InherentProductService) {
                fields.InherentProductService.value = value.InherentProductService
            }

            if (value?.IncomePrice) {
                fields.PartPrice.value = value?.IncomePrice;
            } else {
                fields.PartPrice.value = 0;
            }

            if (!fields?.PartQty?.value) {
                fields.PartQty.value = 1;
            }

            fields.TotalAmount.value = formatMoney((numberWithCommasToBack(fields.PartPrice.value) * (Number(fields.PartQty.value) || 0)) * (Number(fields.TaxAmount.value) || 1));
        }

        if (name === "HasWarranty") {
            fields.UpToMileage.type = !value ? "hidden" : "integer_or_empty"
            fields.UpToMonths.type = !value ? "hidden" : "integer_or_empty"
        }
        return fields;
    }

    const handleDeletePartClick = (item, index) => {
        setConfirmDialogData({
            isOpen: true,
            onClick: () => handleConfirmDeletePartClick(item, index),
            type: "danger",
            content:
                `Are you sure you want to delete item ${item.PartName}?`
            ,
            title: translate("text.confirm_delete_part"),
            buttonLabel: translate("btn.delete")
        })
    }


    const handleDeleteLaborClick = (item, index) => {
        setConfirmDialogData({
            isOpen: true,
            onClick: () => handleConfirmDeleteLaborClick(item, index),
            type: "danger",
            content:
                `Are you sure you want to delete item ${item.Description}?`
            ,
            title: translate("text.confirm_delete_labor"),
            buttonLabel: translate("btn.delete")
        })
    }

    const handleDeleteMiscClick = (item) => {
        setConfirmDialogData({
            isOpen: true,
            onClick: () => handleConfirmDeleteMiscClick(item),
            type: "danger",
            content:
                `Are you sure you want to delete item ${item.Description}?`
            ,
            title: translate("text.confirm_delete_misc_item"),
            buttonLabel: translate("btn.delete")
        })
    }

    const handleDeleteItemClick = (index) => {
        setData(prevData => {
            const dataUpdate = Object.assign({}, prevData);
            dataUpdate.Items = [...dataUpdate.Items];
            dataUpdate.Items.splice(index, 1);
            return dataUpdate;
        });

        setFieldsAction(prevData => {
            const fieldsUpdate = {};
            Object.keys(prevData).forEach(key => {
                const numKey = Number(key);
                if (numKey < index) {
                    fieldsUpdate[numKey] = prevData[key];
                } else if (numKey > index) {
                    fieldsUpdate[numKey - 1] = prevData[key];
                }
            });

            return fieldsUpdate;
        });

        setIsStateDirty(true);
    }

    const getInherentOrDirtyPrice = (item) => {
        if (item) {
            return item;
        } else
            return 0;
    }
    const closeConfirmDialog = () => {
        setConfirmDialogData(Object.assign({}, confirmDialogData, {isOpen: false}))
    }

    const scrollErrorIntoViewItems = (fields, i) => {
        for (const [key, value] of Object.entries(fields)) {
            if (value.errorMessage) {
                const firstErrorInput = document.getElementById(`itemIndex${i}`);

                if (firstErrorInput) {
                    firstErrorInput.parentElement.scrollIntoView({block: "center", behavior: "smooth"});
                    return true;
                }
            }
        }

        return false;
    }

    const scrollErrorIntoViewFieldsItems = (array) => {
        for (let i = 0; i < array.length; i++) {
            scrollErrorIntoViewItems(array[i], i)
        }

        return false;
    }

    const submit = () => {
        let dataItems = {};
        let dataForSubmit = {};

        (data?.Items ?? []).forEach((item, itemIndex) => {
            let actionItems = Object.values(fieldsAction[itemIndex]);

            let newObject = {};

            newObject[itemIndex] = {
                ActionItem: null,
                ActionItemStatusID: null,
                AssignedContactID: null,
                CustomCodeID: null,
                ServiceBayID: null,
                ActionItemDescription: null,
                ShowItemAsSubTotal: null
            }

            actionItems.forEach((it) => {
                newObject[itemIndex][it.name] = it.value;
            })

            dataForSubmit[itemIndex] = {};

            let actionFieldsValidated = fieldsAction;
            actionFieldsValidated[itemIndex] = FieldsManager.validateFields(fieldsAction[itemIndex])
            if (FieldsManager.checkFieldsForErrors(actionFieldsValidated[itemIndex])) {
                Object.assign(dataForSubmit[itemIndex], FieldsManager.getFieldKeyValues(fieldsAction[itemIndex]))
            } else {
                setFieldsAction(actionFieldsValidated)
            }

            dataForSubmit[itemIndex]['Parts'] = item['Parts']
            dataForSubmit[itemIndex]['Labor'] = item['Labor']
        })

        dataItems.WorkOrderID = Number(ID);
        dataItems.Items = dataForSubmit;
        dataItems.InitialComplaint = initialComplaintFields.InitialComplaint.value;
        dataItems.PostRepairNotes = postRepairFields.PostRepairNotes.value;
        dataItems.SurchargeAmount = TotalAmountSupplies();
        dataItems.Misc = Object.assign({}, miscItems);

        if (Object.values(fieldsAction).every(item => FieldsManager.checkFieldsForErrors(item))) {
            dispatch(updateResource({
                user: LocalStorage.get('user'),
                params: dataItems,
                query: {WorkOrderID: ID},
                resource: Resources.WorkOrderParts,
                piggyResource: Resources.WorkOrderParts,
                successMessage: "Labor and parts items saved"
            }));
            setIsStateDirty(false);
        } else {
            setErrors(Object.values(fieldsAction));
        }
    }

    const ShopSuppliesTotalAmount = () => {
        switch (dataSettings?.ShopSuppliesSurchargeTypeID) {
            case 1:
                return 0;
            case 2:
                return totalPriceLabor * (dataSettings?.ShopSuppliesAmount - 1);
            case 3:
                return (totalPriceLabor + totalPriceParts) * (dataSettings?.ShopSuppliesAmount - 1);
            default:
                return 0;
        }
    }

    const TotalAmountSupplies = () => {
        let suppliesAmount = ShopSuppliesTotalAmount()

        if (dataSettings.ShopSuppliesMinAmount && suppliesAmount < dataSettings.ShopSuppliesMinAmount && totalPriceLabor) {
            suppliesAmount = dataSettings.ShopSuppliesMinAmount
        }

        if (dataSettings.ShopSuppliesMaxAmount && suppliesAmount > dataSettings.ShopSuppliesMaxAmount) {
            suppliesAmount = dataSettings.ShopSuppliesMaxAmount
        }

        return suppliesAmount.toFixed(2)
    }

    const handleSetEstimateClick = () => {
        setSelectedItem(data);
        setIsEmailModalOpen(true);
    }

    const handleToggleTemplateImport = () => {
        setIsTemplateImportOpen(!isTemplateImportOpen);
    }

    const toggleAiDialog = (item = null) => {
        if (!aiDialog) {
            setAILoading(true)
            getAiRecon().then((res) => {
                setAiData(processResponse(res)?.data);
                setAILoading(false)
            });
        } else {
            setAdditionalAiInfo("")
        }
        setAiDialog(!aiDialog);
    }

    const toggleAiDialogSingle = (index) => {
        if (!aiDialogSingle) {
            setAILoading(true)
            setAiSingleIndex(index)
            let Complaint = fieldsAction[index].ActionItem.value;
            getAiReconRefreshItem(Complaint).then((res) => {
                // res.data.ActionItems[0].Complaint = Complaint;
                setAiData(processResponse(res)?.data);
                setAILoading(false);
            })

        } else {
            setAdditionalAiInfo("")
        }
        setAiDialogSingle(!aiDialogSingle);
    }

    const askAIAgain = () => {
        setAILoading(true)
        getAiRecon().then((res) => {
            setAiData(processResponse(res)?.data);
            setAILoading(false)
        });
    }

    const askAIAgainSingle = (index) => {
        setAILoading(true)
        setAiSingleIndex(index)
        let Complaint = fieldsAction[index].ActionItem.value
        getAiReconRefreshItem(Complaint).then((res) => {
            // res.data.ActionItems[0].Complaint = Complaint;
            setAiData(processResponse(res)?.data);
            setAILoading(false);
        })
    }

    const AIRefresh = (item, index) => {
        setAIItemLoading(prevState => ({
            ...prevState,
            [index]: true
        }))

        getAiReconRefreshItem(item).then((res) => {
            setAiData(prev => ({
                ...prev,
                ActionItems: prev?.ActionItems.map((value, actionIndex) => {
                    if (actionIndex === index) {
                        return res.data.ActionItems[0];
                    } else return value
                })
            }));
            setAIItemLoading(prevState => ({
                ...prevState,
                [index]: false
            }))
        })
    }

    const fillFromAi = () => {
        let newAiData = aiData
        let newData = [...items];

        newAiData?.ActionItems.forEach(((it, itIndex) => {
            it.isChecked = itemsChecked[itIndex].itemChecked.value

            if (it.isChecked) {
                newData[itIndex] = {
                    "Parts": [],
                    "Labor": []
                }

                let newFields = fieldsAction
                newFields[itIndex] = {}
                newFields[itIndex].ActionItem = it?.Complaint
                newFields[itIndex].ActionItemDescription = it?.Correction

                setFieldsAction(prevState => ({
                    ...prevState,
                    [itIndex]: getFieldsAction(newFields[itIndex], isInvoiced, dataSettings)
                }))


                it?.Labor.forEach((laborItem, index) => {
                    const fillTax = (!data?.IsTaxExempt) && (data?.TaxLabor == 1);
                    const totals = (laborItem?.LaborHours ?? 1) * (dataSettings?.DefaultLaborPrice ?? 1) * (fillTax ? (!data?.TaxAmount ? 1 : data?.TaxAmount) : 1);
                    newData[itIndex]['Labor'][index] = {};
                    newData[itIndex]['Labor'][index].Description = laborItem.LaborDescription;
                    newData[itIndex]['Labor'][index].LaborHours = laborItem?.LaborHours;
                    newData[itIndex]['Labor'][index].LaborPrice = dataSettings?.DefaultLaborPrice;
                    newData[itIndex]['Labor'][index].TaxAmount = fillTax ? data?.TaxAmount : 1;
                    newData[itIndex]['Labor'][index].TaxID = fillTax ? data?.TaxID : null;
                    newData[itIndex]['Labor'][index].Tax = fillTax ? data?.Tax : null;
                    newData[itIndex]['Labor'][index].TotalAmount = totals;
                })
            } else {
                delete newData[itIndex]
            }
        }))

        handlePostRepairNotesInputChange("PostRepairNotes", "")

        newAiData?.PostRepairActions.forEach(((it) => {

            let newPostRepairNotes = postRepairFields?.PostRepairNotes?.value

            newPostRepairNotes += it.Type + "\n"
            newPostRepairNotes += it.Message + "\n"
            newPostRepairNotes += it.Purpose + "\n"

            handlePostRepairNotesInputChange("PostRepairNotes", newPostRepairNotes)

        }))

        setData(prevData => {
            const dataUpdate = Object.assign({}, prevData);
            dataUpdate.Items = newData;
            return dataUpdate;
        });

        setIsStateDirty(true);
        toggleAiDialog();
    }

    const fillFromAiSingle = (itIndex) => {
        let newAiData = aiData
        let newData = {...data};

        newAiData?.ActionItems.forEach(((it, actionItemIndex) => {
            it.isChecked = itemsChecked[actionItemIndex].itemChecked.value

            if (it.isChecked) {
                newData[itIndex] = {
                    "Parts": [],
                    "Labor": []
                }

                let newFields = fieldsAction
                newFields[itIndex] = {}
                newFields[itIndex].ActionItem = it?.Complaint
                newFields[itIndex].ActionItemDescription = it?.Correction

                setFieldsAction(prevState => ({
                    ...prevState,
                    [itIndex]: getFieldsAction(newFields[itIndex], isInvoiced, dataSettings)
                }))

                it?.Labor.forEach((laborItem, index) => {
                    const fillTax = (!dataSettings?.IsTaxExempt) && (dataSettings?.TaxLabor == 1);
                    const totals = (laborItem?.LaborHours ?? 1) * (dataSettings?.DefaultLaborPrice ?? 1) * (fillTax ? !data?.TaxAmount ? 1 : data?.TaxAmount : 1);

                    newData.Items[itIndex]['Labor'][index] = {};
                    newData.Items[itIndex]['Labor'][index].LaborHours = laborItem?.LaborHours;
                    newData.Items[itIndex]['Labor'][index].LaborPrice = dataSettings?.DefaultLaborPrice;
                    newData.Items[itIndex]['Labor'][index].Description = laborItem.LaborDescription;
                    newData.Items[itIndex]['Labor'][index].TaxAmount = fillTax ? data?.TaxAmount : 1;
                    newData.Items[itIndex]['Labor'][index].TaxID = fillTax ? data?.TaxID : null;
                    newData.Items[itIndex]['Labor'][index].Tax = fillTax ? data?.Tax : null;
                    newData.Items[itIndex]['Labor'][index].TaxAmount = fillTax ? data?.TaxAmount : null;
                    newData.Items[itIndex]['Labor'][index].TotalAmount = totals;

                })
            } else {
                delete newData.Items[itIndex]
            }
        }))
        
        setData(newData);
        setIsStateDirty(true)
        toggleAiDialogSingle()
    }

    const getAiRecon = () => {
        return axios.get(
            Env.getWorkOrderAiUrl('prompt', {
                input: initialComplaintFields?.InitialComplaint?.value ?? "",
                make: dataUnit?.Manufacturer,
                model: dataUnit?.Model,
                year: dataUnit?.Year,
                type: dataUnit?.Type,
                engine: dataUnit?.Engine ?? "",
                additional: additionalAiInfo ?? ""
            }),
            {
                headers: {
                    Authorization: `Bearer ${getJWT().access_token}`,
                },
            }
        )
    }

    const getAiReconRefreshItem = (item, index) => {
        return axios.get(
            Env.getWorkOrderAiUrl('prompt', {
                input: item ?? "",
                make: dataUnit?.Manufacturer,
                model: dataUnit?.Model,
                year: dataUnit?.Year,
                type: dataUnit?.Type,
                engine: dataUnit?.Engine ?? "",
                additional: additionalAiInfo ?? ""
            }),
            {
                headers: {
                    Authorization: `Bearer ${getJWT().access_token}`,
                },
            }
        )
    }

    function handleViewReportClick(selectedItem) {
        setSelectedReportItem(selectedItem);
        setIsReportDialogOpen(true);
    }

    function toggleSelectPartDialog() {
        setSelectPartDialogOpen(!selectPartDialogOpen)
    }

    function getAiButtonClass(isInvoiced) {
        return classNames(
            isInvoiced ? "bg-stripes" : "cursor-pointer",
            "flex text-base group items-center p-2 transition duration-150 ease-in-out rounded-lg focus:outline-hidden focus-visible:ring-3 focus-visible:ring-primary-tint focus-visible:ring-opacity-50 bg-inverse hover:bg-primary/30")
    }



    /** Lifecycle
     ================================================================= */
    useEffect(() => {
        dispatch(resetResource());
        fetchData();

        return () => dispatch(resetResource());
    }, [])

    useEffect(() => {
        if (!isDropZoneActive) return;

        const deactivate = () => setIsDropZoneActive(false);
        const onDocDragLeave = (e) => {
            if (!e.relatedTarget) setIsDropZoneActive(false); // cursor left the browser window
        };

        window.addEventListener('drop', deactivate);
        document.addEventListener('dragleave', onDocDragLeave);
        return () => {
            window.removeEventListener('drop', deactivate);
            document.removeEventListener('dragleave', onDocDragLeave);
        };
    }, [isDropZoneActive])

    useEffect(() => {
        if (!resource?.data?.Items || resource.isLoading) return;

        setData(resource.data);

        const nextFieldsAction = resource.data.Items.reduce((acc, it, index) => {
            acc[index] = getFieldsAction(it, isInvoiced, dataSettings);
            return acc;
        }, {});

        setFieldsAction(nextFieldsAction);
    }, [resource, isInvoiced]);

    useEffect(() => {
        if (!isLoadingSecond && secondResource.resource === "work-orders/work-orders/parts/templates/quick") {
            const dataSecond = getProp(secondResource, "data.Items", [])
            const dataMiscSecond = getProp(secondResource, "data.Misc", [])

            setData(prevData => {
                const dataUpdate = Object.assign({}, prevData);

                if (!dataUpdate.Items) {
                    dataUpdate.Items = []
                }

                if (isAppend) {
                    dataUpdate.Items = dataUpdate.Items.concat(dataSecond);
                    dataUpdate.Misc = dataUpdate.Misc.concat(dataMiscSecond);
                } else {
                    dataUpdate.Items = dataSecond;
                    dataUpdate.Misc = dataMiscSecond;
                }

                return dataUpdate;
            });

            setFieldsAction(prevData => {
                const currentLength = isAppend ? (data?.Items?.length ?? 0) : 0;
                const newFieldsAction = isAppend ? {...prevData} : {};

                dataSecond.forEach((item, index) => {
                    newFieldsAction[currentLength + index] = getFieldsAction(item, isInvoiced, dataSettings);
                });

                return newFieldsAction;
            });
        }
    }, [isLoadingSecond])

    const isInitialFieldsSet = useRef(false);
    useEffect(() => {
        if (data && data?.Items && !isInitialFieldsSet.current) {
            isInitialFieldsSet.current = true;
            setInitialComplaintFields(getInitialComplaintFields(data, isInvoiced))
            setPostRepairFields(getPostRepairFields(data, isInvoiced))
        }
    }, [data])

    useEffect(() => {
        if (errors && Object.keys(errors).length > 0) {
            scrollErrorIntoViewFieldsItems(errors);
        }
    }, [errors]);
    /** Component Body
     ================================================================= */
    return (
        <PageTabWithFooter
            isLoading={isLoading}
            buttons={
                [
                    {
                        className: "btn btn-primary",
                        onClick: () => submit(),
                        disabled: !isStateDirty,
                        label: translate("btn.save")
                    },
                    {
                        className: "btn btn-outline",
                        disabled: !isStateDirty,
                        onClick: () => {
                            handleCancelClick();
                        },
                        label: translate("btn.cancel")
                    },
                ]
            }
        >
            <div
                className="py-2 space-y-4 w-full max-w-7xl mx-auto min-w-[60rem] mb-10 mt-4 relative"
                onDragEnter={() => setIsDropZoneActive(true)}
            >
                {!!isInvoiced && (
                    <div className="my-2">
                        <InfoParagraph
                            className=""
                            message={translate("field.WOisInvoiced")}
                        />
                    </div>
                )}

                <div className="flex flex-wrap justify-start gap-4">
                    <Button appearance={'secondary'} addClass={"flex"} disabled={isInvoiced}
                            onClick={() => {
                                toggleAiDialog()
                            }}><img src={Bot} alt="bot" className={"w-5 h-5 mr-3"}/> {translate("btn.ask_ai")}
                    </Button>

                    <Button
                        appearance={'secondary'}
                        toolTip={translate("text.beta_tooltip")}
                        addClass={"flex"}
                        disabled={isInvoiced}
                        onClick={() => {
                            if (dropZoneRef.current) {
                                dropZoneRef.current.click();
                            }

                            if (popoverButtonRef.current) {
                                popoverButtonRef.current.click();
                            }
                        }}>
                        <DocumentIcon className="size-5 mr-2"/>Upload & Fill with AI
                    </Button>

                    <div className="ml-auto flex items-center gap-4">
                        <Button
                            appearance={'primary'}
                            addClass={"flex"}
                            disabled={isInvoiced}
                            onClick={() => {
                                handleToggleTemplateImport();
                            }}
                        >
                            {translate("btn.select_from_template")}
                        </Button>

                        <Button
                            appearance={'primary'}
                            addClass={"flex"}
                            disabled={isInvoiced}
                            onClick={() => {
                                handleSetEstimateClick();
                            }}
                        >
                            {translate("btn.preview_estimate")}
                        </Button>
                    </div>
                </div>

                <FieldsForm
                    fieldsState={initialComplaintFields}
                    isLoading={isLoading || isInitialFieldsSet.current === false}
                    onChange={handleInitialComplaintInputChange}
                    translate={translate}
                />

                <WorkOrdersLaborPartsPrices
                    isResourceLoading={isLoading}
                    totalPriceParts={totalPriceParts}
                    totalPriceLabor={totalPriceLabor}
                    shopSupplies={dataSettings}
                    dataObject={data}
                    dataMiscTotal={dataMiscTotal}
                />

                {(data.OutOfStock?.length !== 0) && !isLoading && !!WoRepairShopON && (
                    <InfoBar type='danger'>
                        <div>
                            {translate("text.part_out_of_stock")}
                            {data.OutOfStock?.map((it, index) => {
                                return <div>{`${it.ProductService} (SKU: ${it.SKU} - Current Stock: ${it.InventoryCount})`}</div>
                            })}
                        </div>
                    </InfoBar>
                )}

                {!!data.IsTaxExempt && (
                    <InfoBar type='warning'>
                        <Tippy content={data.TaxExemptReason ?? ""}>
                            <div>
                                {'This customer is tax-exempt.'}
                            </div>
                        </Tippy>
                    </InfoBar>
                )}

                {items.map((it, index) => {
                    let dataPartsTable = it.Parts;


                    const dataPartsTableCalculate = dataPartsTable.map((it) => {
                        it.CalculatedPartsPrice = numberWithCommasToBack(it.PartPrice) * (Number(it.PartQty) || 0) * (Number(it.TaxAmount ? it.TaxAmount : 1));
                        return it;

                    });

                    const dataPartsTableTotal = dataPartsTableCalculate.reduce((memo, it) => {
                        memo += it.CalculatedPartsPrice
                        return memo
                    }, 0)
                    const dataPartsQtyTotal = dataPartsTable.reduce((memo, it) => memo + (Number(it.PartQty) || 0), 0);
                    const dataPartsPriceTotal = dataPartsTable.reduce((memo, it) => memo + (numberWithCommasToBack(it.PartPrice) || 0), 0);

                    let dataLaborTable = it.Labor;

                    const dataLaborTableCalculate = dataLaborTable.map((it) => {
                        it.CalculatedLaborPrice = numberWithCommasToBack(it.LaborPrice) * (Number(it.LaborHours) || 0) * (Number(it.TaxAmount ? it.TaxAmount : 1));
                        return it;
                    });

                    const dataLaborTableTotal = dataLaborTableCalculate.reduce((memo, it) => {
                        memo += it.CalculatedLaborPrice
                        return memo
                    }, 0)
                    const dataLaborHoursTotal = dataLaborTable.reduce((memo, it) => memo + (Number(it.LaborHours) || 0), 0);
                    const dataLaborPriceTotal = dataLaborTable.reduce((memo, it) => memo + (numberWithCommasToBack(it.LaborPrice) || 0), 0);

                    return (
                        <Card>
                            {/*Action fields*/}
                            <div className={"flex items-center justify-between"}>
                                <h3 className={"text-lg font-bold "}>#{index + 1}</h3>
                                <Button appearance={'secondary'} addClass={"flex mr-auto ml-4"} disabled={isInvoiced}
                                        onClick={() => {
                                            toggleAiDialogSingle(index);
                                        }}><img src={Bot} alt="bot" className={"w-5 h-5"}/>
                                </Button>

                                <button
                                    disabled={isInvoiced}
                                    className={"flex cursor-pointer hover:text-red-600"}
                                    onClick={() => {
                                        handleDeleteItemClick(index);
                                    }}
                                >
                                    <XCircleIcon className={"w-8 h-8"}/>
                                </button>
                            </div>

                            <div className={"grid grid-cols-12 gap-x-6 gap-y-4"} id={`itemIndex${index}`}>
                                <FieldsForm
                                    fieldsState={fieldsAction[index]}
                                    onChange={(name, value) => handleInputChange(name, value, index, fieldsAction[index])}
                                    selects={selects}
                                    isLoading={isLoading}
                                    translate={translate}
                                />
                            </div>

                            {/*Parts*/}
                            <div className={"space-y-4"}>
                                <WorkOrdersLaborPartsPrices
                                    totalPriceParts={dataPartsTableTotal}
                                    totalPriceLabor={dataLaborTableTotal}
                                    totalLabel={'Subtotal'}
                                />

                                <div className="text-base font-bold">Parts</div>

                                <div className="mx-">
                                    <ResourceTable
                                        data={dataPartsTable}
                                        fields={getPartsFields({}, handleViewReportClick)}

                                        translate={translate}
                                        options={
                                            {
                                                behaviour: {
                                                    rowSelect: false,
                                                    canAdjustWidth: false,
                                                    hasMenu: false

                                                },
                                                style: {
                                                    condensed: true,
                                                    isGPUAccelerated: true,
                                                    horizontalLines: true,
                                                    verticalLines: true
                                                }
                                            }
                                        }
                                        tfoot={{
                                            PartQty: () => <div className="text-right font-bold">{dataPartsQtyTotal}</div>,
                                            PartPrice: () => <div className="text-right font-bold">{genericMoneyFormatter(dataPartsPriceTotal)}</div>,
                                            TotalAmount: () => <div className="text-right font-bold">{genericMoneyFormatter(dataPartsTableTotal)}</div>
                                        }}
                                        actions={[
                                            {
                                                title: () => translate('btn.edit'),
                                                visible: () => !isInvoiced,
                                                action: (item) => handleEditPartClick(item, index),
                                                icon: () => PencilIcon
                                            },
                                            {
                                                title: () => translate('btn.delete'),
                                                visible: (it) => !isInvoiced && (it.ParentPartID === null || it.ParentPartID === undefined),
                                                action: (item) => handleDeletePartClick(item, index),
                                                icon: () => TrashIcon
                                            }
                                        ]}

                                        onRowClick={(item) => !isInvoiced && handleEditPartClick(item, index)}
                                    />
                                </div>

                                <NoRecords
                                    show={!dataPartsTable.length}
                                    addClass="p-4"
                                    title="No Parts"
                                    text={translate("text.add_part_button")}
                                />

                                <Buttons
                                    buttons={[
                                        {
                                            label: translate("btn.add_part"),
                                            type: "primary",
                                            disabled: isInvoiced,
                                            onClick: () => handleAddPartClick(index),
                                            className: "btn btn-primary flex ml-auto"
                                        }
                                    ]}
                                />
                            </div>

                            {/*Labor*/}
                            <div className={"space-y-2"}>
                                <div className="text-base font-bold">Labor</div>

                                <ResourceTable
                                    data={dataLaborTable}
                                    fields={getLaborFields({}, data)}

                                    translate={translate}
                                    options={
                                        {
                                            behaviour: {
                                                rowSelect: false,
                                                canAdjustWidth: false,
                                                hasMenu: false

                                            },
                                            style: {
                                                condensed: true,
                                                isGPUAccelerated: true,
                                                horizontalLines: true,
                                                verticalLines: true
                                            }
                                        }
                                    }
                                    tfoot={{
                                        LaborHours: () => <div className="text-right font-bold">{dataLaborHoursTotal}</div>,
                                        LaborPrice: () => <div className="text-right font-bold">{genericMoneyFormatter(dataLaborPriceTotal)}</div>,
                                        TotalAmount: () => <div className="text-right font-bold">{genericMoneyFormatter(dataLaborTableTotal)}</div>
                                    }}
                                    actions={[
                                        {
                                            title: () => translate('btn.edit'),
                                            visible: () => !isInvoiced,
                                            action: (item) => handleEditLaborClick(item, index),
                                            icon: () => PencilIcon
                                        },
                                        {
                                            title: () => translate('btn.delete'),
                                            visible: () => !isInvoiced,
                                            action: (item) => handleDeleteLaborClick(item, index),
                                            icon: () => TrashIcon
                                        }
                                    ]}

                                    onRowClick={(item) => !isInvoiced && handleEditLaborClick(item, index)}
                                />
                                <NoRecords
                                    show={!dataLaborTable.length}
                                    addClass="p-4"
                                    title="No Labor"
                                    text={translate("text.add_labor_button")}
                                />
                                <Buttons
                                    buttons={[
                                        {
                                            label: translate("btn.add_labor"),
                                            type: "primary",
                                            disabled: isInvoiced,
                                            onClick: () => handleAddLaborClick(index),
                                            className: "btn btn-primary flex ml-auto"
                                        }
                                    ]}
                                />

                            </div>
                        </Card>
                    )
                })}

                <button
                    className={"btn btn-primary flex mx-auto"}
                    disabled={isInvoiced}
                    onClick={() => {
                        handleAddNewItemClick();
                    }}
                >
                    Add new item
                </button>

                <Card>
                    <div className={"flex justify-center text-lg"}>Misc. charges</div>
                    <div>
                        <Buttons
                            buttons={[
                                {
                                    label: translate("btn.add_misc"),
                                    type: "primary",
                                    disabled: isInvoiced,
                                    onClick: () => handleCreateMiscClick(),
                                    className: "btn btn-primary flex ml-auto mb-4"

                                }
                            ]}
                        />

                        <ResourceTable
                            data={miscItems}
                            fields={getMiscFields()}

                            translate={translate}
                            options={
                                {
                                    behaviour: {
                                        rowSelect: false,
                                        canAdjustWidth: false,
                                        hasMenu: false

                                    },
                                    style: {
                                        condensed: true,
                                        isGPUAccelerated: true,
                                        horizontalLines: true,
                                        verticalLines: true
                                    }
                                }
                            }
                            tfoot={{
                                MiscQty: () => <div className="text-right font-bold">{dataMiscQtyTotal}</div>,
                                MiscPrice: () => <div className="text-right font-bold">{genericMoneyFormatter(dataMiscPriceTotal)}</div>,
                                TotalAmount: () => <div className="text-right font-bold">{genericMoneyFormatter(dataMiscTotal)}</div>
                            }}
                            actions={[
                                {
                                    title: () => translate('btn.edit'),
                                    visible: () => !isInvoiced,
                                    action: (item) => handleEditMiscClick(item),
                                    icon: () => PencilIcon
                                },
                                {
                                    title: () => translate('btn.delete'),
                                    visible: (it) => !isInvoiced,
                                    action: (item) => handleDeleteMiscClick(item),
                                    icon: () => TrashIcon
                                }
                            ]}

                            onRowClick={!isInvoiced && handleEditMiscClick}
                        />

                        <NoRecords
                            show={!miscItems.length}
                            addClass="p-4"
                            title="No Misc. charges"
                        />
                    </div>

                    {/*<button className={"btn btn-outline flex mx-auto"} onClick={*/}
                    {/*    () => {handleCreateMiscClick()}}*/}
                    {/*> {translate("btn.add_misc")}*/}
                    {/*</button>*/}
                </Card>

                {fieldsToHtml(Object.values(Object.assign({}, postRepairFields)), translate, handlePostRepairNotesInputChange)}

                <ModalConfirm
                    show={confirmDialogData?.isOpen ?? false}
                    type={confirmDialogData?.type}
                    text={confirmDialogData?.content}
                    title={confirmDialogData?.title}
                    onConfirm={confirmDialogData?.onClick}
                    closeButtonLabel={confirmDialogData?.closeButtonLabel ?? translate("btn.cancel")}
                    buttonLabel={confirmDialogData?.buttonLabel}
                    translate={translate}
                    onClose={closeConfirmDialog}
                />

                <ModalSaveResource
                    show={isPartsFormDialogOpen}
                    initialFocusID="PartName"
                    fields={getPartsFields(selectedItem, handleViewReportClick, data, toggleSelectPartDialog)}
                    title={selectedItem ? translate("modal_heading.edit_part_item") : translate("modal_heading.add_part")}
                    onClose={() => {
                        setIsPartsFormDialogOpen(false);
                    }}
                    canSubmit={canSubmitPart}
                    handleInputChange={handlePartsInputChange}
                    onSubmit={(params) => {
                        if (params?.PartNameLabel) {
                            params.PartName = params.PartNameLabel;
                        }

                        const skuMatch = params.PartName.match(/\(SKU:.*?\)/);
                        const skuPart = skuMatch ? skuMatch[0] : "";

                        params.PartName = params.IncludeSku
                            ? params.PartName
                            : params.PartName.replace(skuPart, "").replace(/\s{2,}/g, " ").trim();

                        if (!!params) {
                            if (selectedItem) {
                                let newData = [...items];
                                if (selectedItem.ParentPartID !== undefined) {
                                    params.ParentPartID = selectedItem.ParentPartID
                                }

                                params.ChildPartID = selectedItem.ChildPartID
                                newData[partCreateIndex]['Parts'][selectedItem.dataIndex] = params

                                setIsPartsFormDialogOpen(false);
                                setIsStateDirty(true)
                            } else {
                                let newData = [...items];

                                let ParamsFirst = JSON.parse(JSON.stringify(params));

                                let lengthFirst = newData[partCreateIndex]['Parts'].length
                                newData[partCreateIndex]['Parts'].push(ParamsFirst)

                                ParamsFirst.ChildPartID = lengthFirst

                                let InherentParams = JSON.parse(JSON.stringify(params));

                                if (InherentParams.InherentProductServiceID) {
                                    InherentParams.ProductServiceID = InherentParams.InherentProductServiceID
                                    delete InherentParams.DirtyProductService
                                    delete InherentParams.DirtyProductServiceID

                                    if (InherentParams.InherentProductService) {
                                        InherentParams.PartQty = params.PartQty;
                                        InherentParams.PartName = InherentParams.InherentProductService;
                                        InherentParams.PartPrice = InherentParams.InherentProductPrice ?? 0
                                        InherentParams.ParentPartID = lengthFirst;
                                        InherentParams.TotalAmount = numberWithCommasToBack(InherentParams.PartPrice) * (Number(InherentParams.PartQty) || 0) * (Number(InherentParams.TaxAmount ? InherentParams.TaxAmount : 1));
                                    }
                                    newData[partCreateIndex]['Parts'].push(InherentParams)
                                }

                                let DirtyParams = JSON.parse(JSON.stringify(params));
                                if (DirtyParams.DirtyProductServiceID) {
                                    DirtyParams.ProductServiceID = DirtyParams.DirtyProductServiceID
                                    delete DirtyParams.InherentProductServiceID
                                    delete DirtyParams.InherentProductService

                                    if (DirtyParams.DirtyProductService) {
                                        DirtyParams.PartQty = -1 * params.PartQty;
                                        DirtyParams.PartName = DirtyParams.DirtyProductService;
                                        DirtyParams.PartPrice = DirtyParams.DirtyProductPrice ?? 0
                                        DirtyParams.ParentPartID = lengthFirst;
                                        DirtyParams.TotalAmount = numberWithCommasToBack(DirtyParams.PartPrice) * (Number(DirtyParams.PartQty) || 0) * (Number(DirtyParams.TaxAmount ? DirtyParams.TaxAmount : 1));
                                    }
                                    newData[partCreateIndex]['Parts'].push(DirtyParams)
                                }

                                setIsPartsFormDialogOpen(false);
                                setIsStateDirty(true)
                            }

                            setSelectedItem(params); // in case of server error save form data
                        }
                    }}
                    addFieldContainerClass={"col-span-6"}
                    addBodyClass={"pb-12 text-tm-gray-900"}
                    resource={resource}
                    metadata={getSelects()}
                    htmlAfter={(fields) => {
                        return <ResourceTableDialog
                            widthClass={'max-w-screen'}
                            show={selectPartDialogOpen}
                            dialogResource={dialogResource}
                            resource={Resources.WorkOrderProductServicesReport}
                            title={'Select part'}
                            dispatch={dispatch}
                            options={{
                                style: {
                                    floatingActions: true,
                                }
                            }}
                            isFooterVisible={true}
                            fields={{
                                ProductService: new Field('ProductService', '', [''], false, 'text', {
                                    omitSort: true
                                }),
                                SKU: new Field('SKU', '', [''], false, 'text', {
                                    omitSort: true
                                }),
                                OEMNumber: new Field('OEMNumber', '', [''], false, 'text', {
                                    omitSort: true
                                }),
                                CrossRefNumber: new Field('CrossRefNumber', '', [''], false, 'text', {
                                    omitSort: true
                                }),
                                ProductServiceCategoryID: new Field('ProductServiceCategoryID', '', ['empty'], false, 'select-search', {
                                    label: "ProductServiceCategory",
                                    omitSort: true
                                }),
                                ProductServicePartLocation: new Field('ProductServicePartLocation', '', [''], false, 'text', {
                                    label: "Location",
                                    omitSort: true
                                }),
                                ReorderPoint: new Field('ReorderPoint', '', [''], false, 'text', {
                                    label: "MinRecommendedStock",
                                    omitSort: true
                                }),
                                MaxRecommendedStock: new Field('MaxRecommendedStock', '', [''], false, 'text', {
                                    label: "MaxRecommendedStock",
                                    omitSort: true
                                }),
                                Reserved: new Field('Reserved', '', [''], false, 'custom', {
                                    omitSort: true,
                                    render: (it) => {
                                        return (
                                            <div>
                                                {it.Reserved}
                                            </div>
                                        )
                                    }
                                }),
                                InventoryCount: new Field('InventoryCount', '', [''], false, 'text', {
                                    label: "current_stock",
                                    omitSort: true
                                }),
                                CurrentInventoryValue: new Field('CurrentInventoryValue', '', [''], false, 'money', {
                                    omitSort: true
                                }),
                                AverageBuyPrice: new Field('AverageBuyPrice', '', [''], false, 'money', {
                                    omitSort: true
                                }),
                                AverageSellPrice: new Field('AverageSellPrice', '', [''], false, 'money', {
                                    omitSort: true
                                }),
                                TotalTotalAmount: new Field('TotalTotalAmount', '', [''], false, 'money', {
                                    omitSort: true
                                }),
                            }}
                            fieldsFilter={{
                                query: new Field('query', '', [''], false, 'search', {addContainerClass: "col-span-2"}, {}),
                                ProductServiceCategoryID: new Field('ProductServiceCategoryID', '', [''], false, 'select-search', {addContainerClass: "col-span-2"}, {
                                    isClearable: true
                                }),
                                VendorID: new Field('VendorID', '', [''], false, 'select-search', {
                                    label: 'recommendedVendor',
                                    addContainerClass: "col-span-2"
                                }, {
                                    isClearable: true
                                }),
                                ManufacturerID: new Field('ManufacturerID', '', [], false, 'select-search', {addContainerClass: "col-span-2"}, {
                                    isClearable: true
                                }),
                                ProductServicePartLocationID: new Field('ProductServicePartLocationID', '', [''], false, 'select-search', {addContainerClass: "col-span-2"}, {
                                    isClearable: true
                                })
                            }}
                            defaultAction={(item, ) => {
                                item.PartName = {
                                    value: item.ProductServiceID,
                                    label: item.ProductService,
                                    DirtyProductPrice: item.DirtyProductPrice,
                                    DirtyProductService: item.DirtyProductService,
                                    DirtyProductServiceID: item.DirtyProductServiceID,
                                    IncomePrice: item.IncomePrice,
                                    InherentProductPrice: item.InherentProductPrice,
                                    InherentProductService: item.InherentProductService,
                                    InherentProductServiceID: item.InherentProductServiceID
                                }
                                handlePartsInputChange(fields, 'PartName', item.PartName);
                                setCanSubmitPart(true);
                                setSelectPartDialogOpen(false)
                            }
                            }
                            tableKey="WorkOrderID"
                            defaultQuery={{group: 1}}
                            onCustomActions={[{
                                tooltipText: () => translate('btn.select'),
                                visible: () => checkPerm(Resources.WorkOrderProductServicesReport, READ_PERM),
                                action: (item) => {
                                    item.PartName = {
                                        value: item.ProductServiceID,
                                        label: item.ProductService,
                                        DirtyProductPrice: item.DirtyProductPrice,
                                        DirtyProductService: item.DirtyProductService,
                                        DirtyProductServiceID: item.DirtyProductServiceID,
                                        IncomePrice: item.IncomePrice,
                                        InherentProductPrice: item.InherentProductPrice,
                                        InherentProductService: item.InherentProductService,
                                        InherentProductServiceID: item.InherentProductServiceID
                                    }
                                    handlePartsInputChange(fields, 'PartName', item.PartName);
                                    setCanSubmitPart(true);
                                    setSelectPartDialogOpen(false)
                                },
                                icon: () => PlusIcon
                            }]}
                            onClose={() => {
                                setSelectPartDialogOpen(false)
                            }}
                            limit={20}
                            selects={{
                                ManufacturerID: {
                                    api: 'api/' + Resources.WorkOrderProductsManufacturersQuick,
                                    query: DEFAULT_QUERY,
                                    searchMap: (item) => ({
                                        value: item.ManufacturerID,
                                        label: item.Manufacturer
                                    })
                                },
                                ProductServicePartLocationID: {
                                    api: 'api/' + Resources.WorkOrderPartLocationsQuick,
                                    query: DEFAULT_QUERY,
                                    searchMap: (item) => ({
                                        label: item.ProductServiceLocation,
                                        value: item.ProductServiceLocationID
                                    })
                                },
                                VendorID: {
                                    api: 'api/' + Resources.Vendors,
                                    query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                                    searchMap: (item) => ({
                                        label: item.LegalName + ", " + item.AddressName,
                                        value: item.VendorID
                                    })
                                },
                                ProductServiceCategoryID: {
                                    api: 'api/' + Resources.ProductsServicesCategory,
                                    query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                                    searchMap: (item) => ({
                                        label: item.ProductServiceCategory,
                                        value: item.ProductServiceCategoryID
                                    })
                                }
                            }}
                            translate={translate}
                            closeButtonLabel={translate("btn.close")}
                        />
                    }}
                    translate={translate}
                />

                <ModalSaveResource
                    show={isLaborFormDialogOpen}
                    initialFocusID="LaborPrice"
                    fields={getLaborFields(selectedItem, data)}
                    title={selectedItem?.TotalAmount ? translate("modal_heading.edit_labor_item") : translate("modal_heading.add_labor_item")}
                    onClose={() => {
                        setIsLaborFormDialogOpen(false);
                    }}
                    canSubmit={true}
                    handleInputChange={handleLaborInputChange}
                    onSubmit={(params) => {
                        if (!!params) {
                            if (selectedItem?.LaborHours) {
                                let newData = [...items];
                                newData[laborCreateIndex]['Labor'][selectedItem.dataIndex] = params

                                setIsLaborFormDialogOpen(false);
                                setIsStateDirty(true)

                            } else {
                                let newData = data;

                                let length = newData[laborCreateIndex]['Labor'].length
                                newData[laborCreateIndex]['Labor'][length] = params

                                setIsLaborFormDialogOpen(false);
                                setIsStateDirty(true)
                            }

                            setSelectedItem(params); // in case of server error save form data
                        }
                    }}
                    addFieldContainerClass={"col-span-6"}
                    addBodyClass={"pb-12 text-tm-gray-900"}
                    metadata={getSelects()}
                    resource={resource}
                    translate={translate}
                />

                <ModalDefault
                    show={aiDialog}
                    limitHeight={true}
                    widthClass={'max-w-6xl'}
                    title={translate('text.ai_dialog')}

                    onButtonClick={fillFromAi}
                    buttonLabel={translate('Apply selected suggestions')}

                    customButtonsHTML={(
                        <div>
                            <button
                                className={`btn btn-primary mr-2`}
                                onClick={() => {
                                    askAIAgain();
                                }}
                            >
                                Ask again
                            </button>
                        </div>
                    )}

                    closeButtonLabel={translate('btn.Close')}
                    onClose={toggleAiDialog}
                >
                    <WorkOrdersLaborPartsAiModal
                        aiData={aiData}
                        aiLoading={aiLoading}
                        aiItemLoading={aiItemLoading}
                        translate={translate}
                        additionalAiInfo={additionalAiInfo}
                        setAdditionalAiInfo={setAdditionalAiInfo}
                        setItemsChecked={setItemsChecked}
                        dataUnit={dataUnit}
                        getAiReconRefreshItem={(item, index) => AIRefresh(item, index)}
                    />
                </ModalDefault>

                <ModalDefault
                    show={aiDialogSingle}
                    limitHeight={true}
                    widthClass={'max-w-6xl'}
                    title={translate('text.ai_dialog')}

                    onButtonClick={() => fillFromAiSingle(aiSingleIndex)}
                    buttonLabel={translate('Apply selected suggestions')}

                    customButtonsHTML={(
                        <div>
                            <button
                                className={`btn btn-primary mr-2`}
                                onClick={() => {
                                    askAIAgainSingle(aiSingleIndex);
                                }}
                            >
                                Ask again
                            </button>
                        </div>
                    )}

                    closeButtonLabel={translate('btn.Close')}
                    onClose={toggleAiDialogSingle}
                >
                    <WorkOrdersLaborPartsAiModal
                        aiData={aiData}
                        aiLoading={aiLoading}
                        aiItemLoading={aiItemLoading}
                        translate={translate}
                        additionalAiInfo={additionalAiInfo}
                        setAdditionalAiInfo={setAdditionalAiInfo}
                        setItemsChecked={setItemsChecked}
                        dataUnit={dataUnit}
                        getAiReconRefreshItem={(item, index) => AIRefresh(item, index)}
                    />
                </ModalDefault>

                <ModalDefault
                    show={isErrorCodeHelpModalOpen}
                    limitHeight={true}
                    widthClass={'max-w-3xl'}
                    title={translate('text.error_code_help')}

                    closeButtonLabel={translate('btn.Close')}
                    onClose={() => setIsErrorCodeHelpModalOpen(false)}
                >
                    <ErrorCodeHelpAiModal
                        dataUnit={dataUnit}
                        translate={translate}
                    />
                </ModalDefault>

                <ModalSaveResource
                    show={isMiscFormDialogOpen}
                    initialFocusID=""
                    fields={getMiscFields(selectedItem)}
                    title={selectedItem ? translate("btn.edit_misc") : translate("btn.add_misc")}
                    onClose={() => {
                        setIsMiscFormDialogOpen(false);
                    }}
                    handleInputChange={handleMiscInputChange}
                    onSubmit={(params) => {
                        if (!!params) {
                            let newData = miscItems;
                            if (selectedItem) {
                                newData[selectedItem.dataIndex] = params

                                setIsMiscFormDialogOpen(false);
                                setIsStateDirty(true)
                            } else {
                                let length = newData.length
                                newData[length] = params

                                setIsMiscFormDialogOpen(false);
                                setIsStateDirty(true)
                            }

                            setSelectedItem(params); // in case of server error save form data
                        }
                    }}
                    addFieldContainerClass={"col-span-6"}
                    addBodyClass={"pb-12 text-tm-gray-900"}
                    metadata={getSelects()}
                    resource={resource}
                    translate={translate}
                />


                <EmailEstimate
                    selectedItem={selectedItem}
                    WorkOrder={WorkOrder}
                    show={isEmailModalOpen}
                    onClose={() => {
                        setIsEmailModalOpen(false);
                        setSelectedItem(undefined);
                    }}
                    ID={ID}
                    translate={translate}
                />

                <WoLaborPartsOcr
                    key={isOcrModalOpen ? 1 : 0}
                    show={isOcrModalOpen}
                    ocrFile={ocrFile}
                    id={ID}
                    translate={translate}
                    onSubmit={(OcrData, OcrItems) => {
                        let itemsUpdate;

                        setData(prevData => {
                            const dataUpdate = Object.assign({}, prevData);

                            if (!dataUpdate.Items) {
                                dataUpdate.Items = []
                            }

                            dataUpdate.Items = dataUpdate.Items.concat(OcrData.Items);

                            dataUpdate.Items = dataUpdate.Items.reduce((memo, it) => {
                                if (it?.Parts?.length) {
                                    it.Parts = it.Parts.map(it => {
                                        it.ProductServiceID = null;
                                        return it;
                                    })
                                }

                                memo.push(it);

                                return memo;
                            }, []);

                            itemsUpdate = dataUpdate.Items;

                            if (OcrData.Misc?.length) {
                                dataUpdate.Misc = (dataUpdate.Misc ?? []).concat(OcrData.Misc);
                            }

                            return dataUpdate
                        });

                        const fieldsActionUpdate = Object.values(fieldsAction).concat(OcrItems).reduce((memo, it, index) => {
                            memo[index] = it;
                            return memo;
                        }, {})

                        setFieldsAction(fieldsActionUpdate);
                        setIsStateDirty(true);
                        setIsOcrModalOpen(false)
                        setOcrFile(null);
                    }}
                    dataSettings={dataSettings}
                    getFieldsAction={getFieldsAction}
                    getPartsFields={getPartsFields}
                    getLaborFields={getLaborFields}
                    getMiscFields={getMiscFields}
                    onClose={() => {
                        setIsOcrModalOpen(false)
                        setOcrFile(null);
                    }}
                    selects={selects}
                />

                <DropZoneAlt
                    className={
                        classNames(
                            "absolute inset-0 focus:bg-primary/20",
                            isDropZoneActive ? "z-50" : "-z-10"
                        )
                    }
                    maxFilesAccepted={1}
                    accept={OCR_DOCUMENT_ACCEPTABLE_EXTENSIONS}
                    translate={translate}
                    onDragLeave={() => setIsDropZoneActive(false)}
                    onAcceptFiles={(files) => {
                        setIsDropZoneActive(false);
                        setIsOcrModalOpen(true)
                        setOcrFile(files[0]);
                    }}
                    content={(isDragAccept, isDragReject) => {
                        return (
                            <div
                                ref={dropZoneRef}
                                className={classNames(
                                    isDragAccept ? "border-2 border-dashed border-green-600 bg-green-600/10" : undefined,
                                    isDragReject ? " border-2 border-dashed border-red-600 bg-red-600/10" : undefined,
                                    !isDragAccept && !isDragReject ? "border-transparent" : undefined,
                                    "pb-4 min-h-[8rem] absolute top-0 left-0 right-0 bottom-0 z-50 rounded-card"
                                )}>

                            </div>
                        )
                    }}
                />
            </div>

            <InventoryReportDialog
                isReportDialogOpen={isReportDialogOpen}
                dialogResource={dialogResource}
                resource={Resources.WorkOrderProductServicesReport}
                dispatch={dispatch}
                thirdResource={thirdResource}
                translate={translate}
                setIsReportDialogOpen={setIsReportDialogOpen}
                selectedReportItem={selectedReportItem}
            />

            <ModalSaveResource
                show={isTemplateImportOpen}
                fields={getTemplateImportFields()}
                handleInputChange={(fields, name, value) => {
                    setImportMetadata(value?.metadata);
                    return FieldsManager.updateField(fields, name, value)
                }}

                title={translate("modal_heading.select_template")}
                onClose={() => {
                    setIsTemplateImportOpen(false);
                    setSelectedItem({})
                    setImportMetadata(null)
                }}
                onSubmit={(params) => {
                    if (!!params) {
                        dispatch(getSecondResource({
                            user: getUser(),
                            resource: Resources.WorkOrderTemplatesQuick,
                            query: {
                                WorkOrderTemplateID: params.ImportTemplateID,
                                OrganizationID: data.OrganizationID
                            }
                        }))

                        setIsAppend(false)
                        setIsStateDirty(true)
                        setIsTemplateImportOpen(false)
                        setImportMetadata(null)
                    }
                }}
                addFieldContainerClass={"col-span-full"}
                addBodyClass={"pb-48 text-tm-gray-900"}
                isLoading={isLoading}
                htmlAfter={
                    !!importMetadata && (
                        <div className={"grid justify-start ml-4 text-base gap-y-2"}>
                            <p><b>Selected template:</b></p>
                            <p>Description: {importMetadata?.Description}</p>
                            <p>Notes: {importMetadata?.Notes}</p>
                            <p>Total Amount: {genericMoneyFormatter(importMetadata?.TotalAmount)}</p>
                        </div>)
                }
                metadata={
                    {
                        ImportTemplateID: {
                            api: 'api/' + Resources.WorkOrderTemplatesQuick,
                            query: {},
                            searchMap: (it) => {
                                return ({
                                    label: it.Description,
                                    value: it.WorkOrderTemplateID,
                                    metadata: it
                                })
                            }
                        }
                    }
                }
                resource={resource}
                translate={translate}
                buttonLabel={translate("btn.apply")}
                secondaryButtonLabel={translate("btn.append")}
                onSecondaryButtonClick={(params) => {

                    if (!!params) {
                        dispatch(getSecondResource({
                            user: getUser(),
                            resource: Resources.WorkOrderTemplatesQuick,
                            query: {
                                WorkOrderTemplateID: params.ImportTemplateID,
                                OrganizationID: data.OrganizationID
                            }
                        }))

                        setIsAppend(true)
                        setIsStateDirty(true)
                        setIsTemplateImportOpen(false)
                        setImportMetadata(null)
                    }
                }}
            />

        </PageTabWithFooter>
    )
}

const getInitialComplaintFields = (item = {}, isInvoiced) => {
    const fieldTemplates = {
        InitialComplaint: new Field('InitialComplaint', '', [''], isInvoiced, 'textarea'),
    }

    return fillFieldsFromData(fieldTemplates, item)
}

const getPostRepairFields = (item = {}, isInvoiced) => {
    const fieldTemplates = {
        PostRepairNotes: new Field('PostRepairNotes', '', [''], isInvoiced, 'textarea', {}, {rows: 10}),
    }

    return fillFieldsFromData(fieldTemplates, item)
}

const getFieldsAction = (item = {}, isInvoiced, dataSettings) => {
    const WoRepairShopON = getProp(LocalStorage.get('lookup'), 'FeatureFlags.WORepairShopON')
    const WOPayON = getProp(LocalStorage.get('lookup'), 'FeatureFlags.WOPayON')

    const fieldTemplates = {
        ActionItem: new Field('ActionItem', '', ['empty'], isInvoiced, 'textarea', {addContainerClass: "col-span-6"}),
        ActionItemDescription: new Field('ActionItemDescription', '', [''], isInvoiced, 'textarea', {addContainerClass: "col-span-6"}),
        ActionItemStatusID: new Field('ActionItemStatusID', 1, ['empty'], isInvoiced, 'select', {addContainerClass: "col-span-4"}),
        ...(WOPayON ? {
            ChargeToContactID: new Field("ChargeToContactID", '', [], false, 'select-search', {
                addContainerClass: 'col-span-4',
                label: "ChargeTo"
            })
        } : null),
        CustomCodeID: new Field('CustomCodeID', '', dataSettings?.RequireRepairCode ? ['empty'] : [''], isInvoiced, 'select-search', {
            addContainerClass: "col-span-4",
            isClearable: true
        }),
        ...(WoRepairShopON ? {
            ServiceBayID: new Field('ServiceBayID', '', [], isInvoiced, 'select-search', {
                addContainerClass: "col-span-3",
                isClearable: true,
                fieldOptions: (it) => {
                    return (
                        <FieldOptions
                            options={[
                                {
                                    icon: InformationCircleIcon,
                                    toolTip: it.value?.metadata?.Notes,
                                    isVisible: !!it.value?.metadata
                                }
                            ]}
                        />
                    )
                }
            }),
            AssignedContactID: new Field('AssignedContactID', '', dataSettings?.RequireTechnician ? ['empty'] : [''], isInvoiced, 'select-search', {
                addContainerClass: "col-span-3",
                isClearable: true
            }),
            ShowItemAsSubTotal: new Field('ShowItemAsSubTotal', '', [], isInvoiced, 'checkbox', {
                addContainerClass: "col-span-2",
            }),
        } : null)
    }

    return fillFieldsFromData(fieldTemplates, item)
}

const getPartsFields = (item = {}, handleViewReportClick, data, toggleSelectPartDialog, isOcrModal) => {
    // item.CalculatedPartsPrice = (numberWithCommasToBack(item.PartPrice) * (Number(item.PartQty) ?? 0) * (Number(item.TaxAmount) ?? 0).toString())
    // item.TotalAmount = formatMoney(item.TotalAmount)

    const fieldTemplates = {
        ProductServiceID: new Field('ProductServiceID', '', [''], false, 'hidden', {hideTable: true}),
        DirtyProductServiceID: new Field('DirtyProductServiceID', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        PartNameLabel: new Field('PartNameLabel', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        InherentProductServiceID: new Field('InherentProductServiceID', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        DirtyProductService: new Field('DirtyProductService', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        InherentProductService: new Field('InherentProductService', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        DirtyProductPrice: new Field('DirtyProductPrice', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        InherentProductPrice: new Field('InherentProductPrice', '', [''], false, 'hidden', {
            hideTable: true,
            hideDialog: true
        }),
        PartName: new Field('PartName', '', ['empty'], false, isOcrModal ? 'text' : 'select-search', {
            addContainerClass: "col-span-full",
            render: (it) => {

                return handleViewReportClick && !!it.ProductServiceID ?
                    <CellButton
                        className="block leading-5 py-0.5 -mx-2 px-2 rounded-btn text-left disabled:text-tm-gray-700 disabled:hover:text-tm-gray-700 disabled:hover:bg-transparent hover:text-primary text-primary-shade font-btn hover:bg-primary-transparent focus-visible:bg-primary-transparent focus:outline-hidden focus:ring-0"
                        onClick={() => {
                            handleViewReportClick(it);
                        }}
                    >
                        <div>{it.PartName}</div>
                    </CellButton>

                    : it.PartName
            },
            fieldOptions: (it) => {
                if (isOcrModal) {
                    return null
                }

                it.ProductServiceID = item.ProductServiceID

                if (it.value) {
                    if (item.PartName !== it.value.value) {
                        it.ProductServiceID = it.value.value
                    }
                }

                return (
                    <FieldOptions
                        options={[
                            {
                                icon: InformationCircleIcon,
                                onClick: () => {
                                    handleViewReportClick(it)
                                },
                                isVisible: !!it.value
                            }
                        ]}
                    />
                )
            },
            htmlAfterField: (it) => {
                if (isOcrModal) {
                    return null;
                }

                return (<Tippy content={"You don't have permission for this action"}
                               disabled={checkPerm(Resources.WorkOrderProductServicesReport, READ_PERM)}>
                        <span>
                            <button
                                onClick={() => toggleSelectPartDialog()}
                                className="btn btn-input"
                                disabled={!checkPerm(Resources.WorkOrderProductServicesReport, READ_PERM)}
                            >
                                <PlusIcon/>
                            </button>
                        </span>
                </Tippy>)
            }
        }),
        IncludeSku: new Field('IncludeSku', 1, [''], false, 'checkbox', {addContainerClass: "col-span-6"}),
        PartQty: new Field('PartQty', '', ['empty'], false, 'integer_new', {addContainerClass: "col-span-3", addTableHeaderClass: "mr-auto"}),
        PartPrice: new Field('PartPrice', '', ['empty'], false, 'float', {
            addContainerClass: "col-span-3",
            render: (it) => genericMoneyFormatter(it.PartPrice)
        }),

        TaxID: new Field('TaxID', '', [''], true, 'select-search', {
            addContainerClass: "col-span-3",
            hideTable: true
        }, {isClearable: true}),
        TaxAmount: new Field('TaxAmount', '1', [''], false, 'hidden', {
            addContainerClass: "col-span-3",
            hideTable: true,
            hideDialog: true
        }),
        Tax: new Field('Tax', '', [''], false, 'text', {
            addContainerClass: "col-span-3",
            hideDialog: true,
            render: (it) => it.Tax || (it.TaxAmount > 0 && it.TaxAmount !== 1 ? genericMoneyFormatter(it.TaxAmount) : null)
        }),
        TotalAmount: new Field('TotalAmount', '', [''], true, 'money', {
            addContainerClass: "col-span-3",
            omitSort: true,
            render: (it) => genericMoneyFormatter(numberWithCommasToBack(it.TotalAmount))
        }),
        HasWarranty: new Field('HasWarranty', '', [''], false, 'checkbox', {
            label: "HasWarranty",
            hasActiveBadge: true,
            render: (it) => {
                return (
                    <div className={"flex justify-center"}>{!!it.HasWarranty
                        ?
                        <Tippy
                            content={(!!it.UpToMileage ? "Up to mileage: " + it.UpToMileage : "") + " " + (!!it.UpToMonths ? "Up to months: " + it.UpToMonths : "")}>
                            <CheckCircleIcon className="w-5 h-5 text-green-600"/>
                        </Tippy>
                        :
                        <>
                            <XMarkIcon className="w-5 h-5 text-tm-gray-700"/>
                        </>
                    }</div>

                )
            },
            addContainerClass: "col-span-3"
        }),
        UpToMileage: new Field('UpToMileage', '0', [''], false, !item.HasWarranty ? "hidden" : 'integer_or_empty', {
            addContainerClass: "col-span-3",
            hideTable: true
        }),
        UpToMonths: new Field('UpToMonths', '0', [''], false, !item.HasWarranty ? "hidden" : 'integer_or_empty', {
            addContainerClass: "col-span-3",
            hideTable: true
        }),
        Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: "col-span-full"}, {rows: 8})
    }

    let filledFields = fillFieldsFromData(fieldTemplates, item)

    if (!item.PartName) {
        const fillTax = (!data?.IsTaxExempt) && (data?.TaxParts == 1);
        filledFields.TaxID.value = fillTax ? {
            label: data?.Tax,
            value: data?.TaxID,
            amount: data?.TaxAmount
        } : null;
        filledFields.Tax.value = fillTax ? data?.Tax : null;
    }

    if (filledFields.TotalAmount.value) {
        filledFields.TotalAmount.value = formatMoney(filledFields.TotalAmount.value)
    }

    return filledFields
}

const getLaborFields = (item = {}, data) => {
    // item.CalculatedLaborPrice = numberWithCommasInputChange((numberWithCommasToBack(item.LaborPrice) * Number(item.LaborHours) ?? 0).toString())
    // item.TotalAmount = formatMoney(item.TotalAmount)
    const fieldTemplates = {
        Description: new Field('Description', '', [], false, 'textarea', {addContainerClass: "col-span-full"}, {rows: 4}),
        LaborHours: new Field('LaborHours', '', ['empty'], false, 'float', {
            addContainerClass: "col-span-3",
            addTableHeaderClass: "mr-auto"
        }),
        LaborPrice: new Field('LaborPrice', '', ['empty'], false, 'money', {
            addContainerClass: "col-span-3",
            addTableHeaderClass: "mr-auto"
        }),
        TaxID: new Field('TaxID', '', [''], true, 'select-search', {
            addContainerClass: "col-span-3",
            hideTable: true
        }, {isClearable: true}),
        TaxAmount: new Field('TaxAmount', 1, [''], false, 'float', {
            addContainerClass: "col-span-3",
            hideTable: true,
            hideDialog: true
        }),
        Tax: new Field('Tax', '', [''], false, 'text', {
            addContainerClass: "col-span-3",
            hideDialog: true,
            render: (it) => it.Tax || (it.TaxAmount > 0 && it.TaxAmount !== 1 ? genericMoneyFormatter(it.TaxAmount) : null)
        }),
        TotalAmount: new Field('TotalAmount', '', [''], true, 'money', {
            addContainerClass: "col-span-3",
            omitSort: true,
            render: (it) => genericMoneyFormatter(numberWithCommasToBack(it.TotalAmount))
        }),
        Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: "col-span-full"}, {rows: 4})
    }

    let filledFields = fillFieldsFromData(fieldTemplates, item)

    if (!item.Description) {
        const fillTax = (!data?.IsTaxExempt) && (data?.TaxLabor == 1);
        filledFields.TaxID.value = fillTax ? {
            label: data?.Tax,
            value: data?.TaxID,
            amount: data?.TaxAmount
        } : null;
        filledFields.Tax.value = fillTax ? data?.Tax : null;
    }

    if (filledFields.TotalAmount.value) {
        filledFields.TotalAmount.value = formatMoney(filledFields.TotalAmount.value)
    }

    if (filledFields.TaxID.value) {
        filledFields.TaxAmount.value = filledFields.TaxID?.value?.amount ?? filledFields.TaxAmount.value
        filledFields.TotalAmount.value = formatMoney((numberWithCommasToBack(filledFields.LaborPrice.value) * (Number(filledFields.LaborHours.value) || 0)) * (Number(filledFields.TaxAmount.value) || 1));
    }

    if (!item.Description) {
        filledFields.TotalAmount.value = formatMoney((numberWithCommasToBack(filledFields.LaborPrice.value) * (Number(filledFields.LaborHours.value) || 0)) * (Number(filledFields.TaxAmount.value) || 1));
    }

    return filledFields
}

const getMiscFields = (item = {}) => {
    const WOPayON = getProp(LocalStorage.get('lookup'), 'FeatureFlags.WOPayON')

    const fieldTemplates = {
        Description: new Field('Description', '', ['empty'], false, 'textarea', {addContainerClass: "col-span-full"}),
        MiscQty: new Field('MiscQty', '', ['empty'], false, 'float', {addContainerClass: "col-span-3", addTableHeaderClass: "mr-auto"}),
        MiscPrice: new Field('MiscPrice', '', ['empty'], false, 'float', {addContainerClass: "col-span-3"}),
        TaxID: new Field('TaxID', '', [''], true, 'select-search', {
            addContainerClass: "col-span-3",
            hideTable: true
        }, {isClearable: true}),
        Tax: new Field('Tax', '', [''], false, 'text', {addContainerClass: "col-span-3", hideDialog: true}),
        TaxAmount: new Field('TaxAmount', 1, [''], false, 'float', {
            addContainerClass: "col-span-3",
            hideTable: true,
            hideDialog: true
        }),
        TotalAmount: new Field('TotalAmount', '', [''], true, 'money', {addContainerClass: "col-span-3",}),
        ...(WOPayON ? {
            ChargeToContactID: new Field("ChargeToContactID", '', [], false, 'select-search', {
                addContainerClass: 'col-span-3',
                label: "ChargeTo",
                hideTable: true
            }),
            ChargeToContact: new Field("ChargeToContact", '', [], false, 'text', {
                addContainerClass: 'col-span-3',
                label: "ChargeTo",
                hideDialog: true
            }),

        } : null)
    }

    let filledFields = fillFieldsFromData(fieldTemplates, item)

    if (filledFields.TotalAmount.value) {
        filledFields.TotalAmount.value = formatMoney(filledFields.TotalAmount.value)
    }

    return filledFields
}

const getTemplateImportFields = (item = {}) => {
    const fieldTemplates = {
        ImportTemplateID: new Field('ImportTemplateID', '', ['empty'], false, 'select-search', {addContainerClass: "col-span-full"}, {isClearable: true}),
    }

    return fieldTemplates
}

function getSelects() {
    return {
        PartName: {
            api: 'api/' + Resources.WorkOrderPartsQuick,
            query: {},
            searchMap: (it) => {
                return ({
                    label: it.ProductService + (!!it.SKU ? ' (SKU: ' + it.SKU + ")" : "") + (!!it.OEMNumber ? " (OEM: " + it.OEMNumber + ")" : "")
                        + (!!it.ProductServiceCategoryID ? " - " + it.ProductServiceCategory : ""),
                    value: it.ProductServiceID,
                    DirtyProductServiceID: it.DirtyProductServiceID,
                    DirtyProductService: it.DirtyProductService,
                    InherentProductServiceID: it.InherentProductServiceID,
                    InherentProductService: it.InherentProductService,
                    InherentProductPrice: it.InherentProductPrice,
                    DirtyProductPrice: it.DirtyProductPrice,
                    IncomePrice: it?.IncomePrice ?? ""
                })
            }
        },
        TaxID: {
            api: 'api/' + Resources.AccountingTaxesQuick,
            query: {},
            searchMap: (it) => {
                return ({
                    label: it.Tax,
                    value: it.TaxID,
                    amount: it.Amount
                })
            }
        },
        ChargeToContactID: {
            api: 'api/' + Resources.ContactsQuick,
            query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
            searchMap: (item) => ({
                value: item.ContactID,
                label: item.FirstName + ' ' + item.LastName,
                Contact: item
            })
        }
    }
}





